import { Flex } from "@chakra-ui/react";
import { FaStar } from "react-icons/fa";
import colors from "common/theme/foundations/colors";

const Rating = ({ value, onChange }) => {
  return (
    <Flex>
      {[...Array(5)].map((_, index) => {
        const ratingValue = index + 1;
        return (
          <FaStar
            key={index}
            color={ratingValue <= value ? colors.orange : colors.grey}
            size={16}
            style={{
              transition: "color 0.2s",
              cursor: onChange ? "pointer" : "default",
            }}
            onMouseEnter={onChange ? () => {} : undefined}
            onMouseLeave={onChange ? () => {} : undefined}
            onClick={onChange ? () => onChange(ratingValue) : undefined}
          />
        );
      })}
    </Flex>
  );
};

export default Rating;
